<template>
  <div class="col-lg-4">
    <div class="comment">
      <img src="@/assets/icon/heart-beat-circle.png" alt="heart beat circle">
      <div>
        {{ comment.name }}<br/>
        {{ comment.title }}
      </div>
      <p>{{ comment.comment }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Comment',
  props: ['comment']
}
</script>

<style scoped lang="scss">
.comment {
  padding: 0.5rem;
  img {
    display: inline;
    height: 2rem;
    width: 2rem;
    margin: -1.5rem 1rem 0 0;
  }
  div {
    display: inline-block;
  }
  p {
    color: $gray-600;
  }
}
@media (min-width: map-get($grid-breakpoints, "sm")) {
  .comment {
    padding: 1.5rem;
  }
}
</style>
